const getClipboard = async (): Promise<string> => {
  return await navigator.clipboard.readText();
};

const setClipboard = async (value: string): Promise<void> => {
  await navigator.clipboard.writeText(value);
};

export { getClipboard, setClipboard };
